import { publishSubdomain } from './PublishStore';

export const updatePublishSubdomain = (value) => publishSubdomain.update((oldValue) => value);
